// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-page {
  padding: 2rem 0;
  min-height: 80vh;
}

.weather-page .page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  color: var(--text-primary);
}

.weather-intro {
  margin-bottom: 2rem;
}

.intro-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.intro-card p {
  color: var(--text-primary);
  line-height: 1.6;
  margin: 0 0 1rem 0;
}

.no-data-info {
  background: var(--bg-secondary);
  border-left: 4px solid var(--accent-primary);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.no-data-info strong {
  color: var(--accent-primary);
  font-size: 1.1rem;
  display: block;
  margin-bottom: 0.5rem;
}

.no-data-info p {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.95rem;
}

/* Fixed Tab Navigation */
.weather-tabs-nav-fixed {
  position: sticky;
  top: 90px;
  z-index: 100;
  background: var(--bg-primary);
  box-shadow: 0 2px 8px var(--shadow-primary);
  margin-bottom: 1rem;
}

.weather-tabs-nav-wrapper {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.weather-tabs-nav-wrapper::-webkit-scrollbar {
  display: none;
}

.weather-tab-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
  min-width: 70px;
}

.weather-tab-button::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 3px;
  background: transparent;
  transition: background 0.3s ease;
}

.weather-tab-button:hover {
  color: var(--text-primary);
  background: var(--bg-secondary);
  border-radius: 8px;
}

.weather-tab-button.active {
  color: var(--accent-primary);
  background: var(--bg-secondary);
  border-radius: 8px;
}

.weather-tab-button.active::after {
  background: var(--accent-primary);
}

.weather-tab-icon {
  font-size: 1.3rem;
  line-height: 1;
}

.weather-tab-label {
  font-size: 0.75rem;
  line-height: 1.2;
  text-align: center;
}

/* Scrollable Content */
.weather-content-scroll {
  position: relative;
  max-width: 100%;
}

.weather-content-section {
  margin-bottom: 3rem;
  scroll-margin-top: 140px;
}

.section-heading {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
  text-align: center;
}

.content-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 2rem;
}

.content-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 1rem 0;
}

.content-card h4 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 1.5rem 0 0.75rem 0;
}

.content-card p {
  color: var(--text-primary);
  line-height: 1.6;
  margin: 0 0 1rem 0;
}

.content-card a {
  color: var(--accent-primary);
  text-decoration: none;
  font-weight: 500;
}

.content-card a:hover {
  text-decoration: underline;
}

.info-box {
  background: var(--bg-secondary);
  border-left: 4px solid var(--accent-primary);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1.5rem 0;
}

.info-box.warning {
  border-left-color: #f59e0b;
  background: var(--bg-tertiary);
}

.info-box h4 {
  margin-top: 0;
  color: var(--text-primary);
}

.info-box p {
  margin-bottom: 0.75rem;
}

.info-box p:last-child {
  margin-bottom: 0;
}

.missing-data {
  background: var(--bg-secondary);
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1.5rem;
}

.missing-data h4 {
  margin-top: 0;
  color: var(--text-primary);
}

.missing-data ul {
  list-style: none;
  padding: 0;
  margin: 0.75rem 0 0 0;
}

.missing-data li {
  color: var(--text-secondary);
  padding: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
}

.missing-data li::before {
  content: '—';
  position: absolute;
  left: 0;
  color: var(--text-secondary);
}

.content-card ol,
.content-card ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.content-card li {
  color: var(--text-primary);
  line-height: 1.6;
  margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .weather-tabs-nav-fixed {
    top: 80px;
  }

  .weather-tabs-nav-wrapper {
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
  }

  .weather-tab-button {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
    gap: 0.2rem;
    min-width: 60px;
  }

  .weather-tab-icon {
    font-size: 1.1rem;
  }

  .weather-tab-label {
    font-size: 0.65rem;
    display: block;
  }

  .weather-content-section {
    margin-bottom: 2rem;
    scroll-margin-top: 100px;
  }

  .section-heading {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .content-card {
    padding: 1.5rem;
  }

  .content-card h3 {
    font-size: 1.3rem;
  }

  .content-card h4 {
    font-size: 1.1rem;
  }

  .intro-card {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .weather-tabs-nav-fixed {
    top: 80px;
  }

  .weather-tab-button {
    padding: 0.35rem 0.4rem;
    font-size: 0.7rem;
    gap: 0.15rem;
    min-width: 55px;
  }

  .weather-tab-label {
    display: block;
    font-size: 0.6rem;
  }

  .weather-tab-icon {
    font-size: 1rem;
  }

  .weather-content-section {
    margin-bottom: 1.5rem;
  }

  .content-card {
    padding: 1rem;
  }

  .content-card h3 {
    font-size: 1.2rem;
  }

  .info-box {
    padding: 1rem;
  }

  .missing-data {
    padding: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/WeatherPage/WeatherPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".weather-page {\r\n  padding: 2rem 0;\r\n  min-height: 80vh;\r\n}\r\n\r\n.weather-page .page-title {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.weather-intro {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.intro-card {\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.intro-card p {\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.no-data-info {\r\n  background: var(--bg-secondary);\r\n  border-left: 4px solid var(--accent-primary);\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.no-data-info strong {\r\n  color: var(--accent-primary);\r\n  font-size: 1.1rem;\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.no-data-info p {\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* Fixed Tab Navigation */\r\n.weather-tabs-nav-fixed {\r\n  position: sticky;\r\n  top: 90px;\r\n  z-index: 100;\r\n  background: var(--bg-primary);\r\n  box-shadow: 0 2px 8px var(--shadow-primary);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.weather-tabs-nav-wrapper {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1rem;\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n.weather-tabs-nav-wrapper::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.weather-tab-button {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0.5rem 0.75rem;\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 3px solid transparent;\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  min-width: 70px;\r\n}\r\n\r\n.weather-tab-button::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -3px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: transparent;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.weather-tab-button:hover {\r\n  color: var(--text-primary);\r\n  background: var(--bg-secondary);\r\n  border-radius: 8px;\r\n}\r\n\r\n.weather-tab-button.active {\r\n  color: var(--accent-primary);\r\n  background: var(--bg-secondary);\r\n  border-radius: 8px;\r\n}\r\n\r\n.weather-tab-button.active::after {\r\n  background: var(--accent-primary);\r\n}\r\n\r\n.weather-tab-icon {\r\n  font-size: 1.3rem;\r\n  line-height: 1;\r\n}\r\n\r\n.weather-tab-label {\r\n  font-size: 0.75rem;\r\n  line-height: 1.2;\r\n  text-align: center;\r\n}\r\n\r\n/* Scrollable Content */\r\n.weather-content-scroll {\r\n  position: relative;\r\n  max-width: 100%;\r\n}\r\n\r\n.weather-content-section {\r\n  margin-bottom: 3rem;\r\n  scroll-margin-top: 140px;\r\n}\r\n\r\n.section-heading {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 1.5rem 0;\r\n  text-align: center;\r\n}\r\n\r\n.content-card {\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n}\r\n\r\n.content-card h3 {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.content-card h4 {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 1.5rem 0 0.75rem 0;\r\n}\r\n\r\n.content-card p {\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.content-card a {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.content-card a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.info-box {\r\n  background: var(--bg-secondary);\r\n  border-left: 4px solid var(--accent-primary);\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  margin: 1.5rem 0;\r\n}\r\n\r\n.info-box.warning {\r\n  border-left-color: #f59e0b;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.info-box h4 {\r\n  margin-top: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.info-box p {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.info-box p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.missing-data {\r\n  background: var(--bg-secondary);\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.missing-data h4 {\r\n  margin-top: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.missing-data ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0.75rem 0 0 0;\r\n}\r\n\r\n.missing-data li {\r\n  color: var(--text-secondary);\r\n  padding: 0.5rem 0;\r\n  padding-left: 1.5rem;\r\n  position: relative;\r\n}\r\n\r\n.missing-data li::before {\r\n  content: '—';\r\n  position: absolute;\r\n  left: 0;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.content-card ol,\r\n.content-card ul {\r\n  margin: 1rem 0;\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.content-card li {\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .weather-tabs-nav-fixed {\r\n    top: 80px;\r\n  }\r\n\r\n  .weather-tabs-nav-wrapper {\r\n    gap: 0.25rem;\r\n    padding: 0.5rem 0.75rem;\r\n  }\r\n\r\n  .weather-tab-button {\r\n    padding: 0.4rem 0.5rem;\r\n    font-size: 0.75rem;\r\n    gap: 0.2rem;\r\n    min-width: 60px;\r\n  }\r\n\r\n  .weather-tab-icon {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .weather-tab-label {\r\n    font-size: 0.65rem;\r\n    display: block;\r\n  }\r\n\r\n  .weather-content-section {\r\n    margin-bottom: 2rem;\r\n    scroll-margin-top: 100px;\r\n  }\r\n\r\n  .section-heading {\r\n    font-size: 1.5rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .content-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .content-card h3 {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .content-card h4 {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .intro-card {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .weather-tabs-nav-fixed {\r\n    top: 80px;\r\n  }\r\n\r\n  .weather-tab-button {\r\n    padding: 0.35rem 0.4rem;\r\n    font-size: 0.7rem;\r\n    gap: 0.15rem;\r\n    min-width: 55px;\r\n  }\r\n\r\n  .weather-tab-label {\r\n    display: block;\r\n    font-size: 0.6rem;\r\n  }\r\n\r\n  .weather-tab-icon {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .weather-content-section {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .content-card {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .content-card h3 {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .info-box {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .missing-data {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
